import { FilterService } from './../../shared/services/filter.service';
import { FormControl } from '@angular/forms';
import {
  FilterMunicipalities,
  ImportMunicipalities,
  RemoveMunicipality,
} from './../../shared/ngxs/action/municipality.action';
import { MunicipalityState } from './../../shared/ngxs/state/municipality.state';
import { Subscription, Observable } from 'rxjs';
import { ManageMunicipalityComponent } from './../manage-municipality/manage-municipality.component';
import { MunicipalityModel } from './../../shared/models/municipality.model';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { OperationMode } from 'src/app/shared/models/enum.model';
import { MUNICIPALITIES_DATA } from 'src/app/shared/data/shared-data';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Select, Store } from '@ngxs/store';
import { TranslateService } from '@ngx-translate/core';
import { SetTitle } from 'src/app/shared/ngxs/action/account.action';
import { MunicipalityFilter } from 'src/app/shared/models/municipality-filter.mode';
import { AccountInfo } from 'src/app/shared/models/accountInfo.model';
import { AccountState } from 'src/app/shared/ngxs/state/account.state';

@Component({
  selector: 'app-municipalities',
  templateUrl: './municipalities.component.html',
  styleUrls: ['./municipalities.component.scss'],
  providers: [FilterService],
})
export class MunicipalitiesComponent implements OnInit, OnDestroy {
  @ViewChild('paginator')
  paginator: MatPaginator;

  @Select(MunicipalityState.municipalities)
  municipalities$: Observable<MunicipalityModel[]>;

  @Select(MunicipalityState.municipalitiesTotal)
  municipalitiesTotal$: Observable<number>;

  @Select(AccountState.account)
  account$: Observable<AccountInfo>;

  isAdministrator = false;
  columnsToDisplay: string[] = ['name', 'city', 'num-of-buildings', 'actions'];
  dataSource = new MatTableDataSource<MunicipalityModel>();
  pageSize = 5;
  pageSizeOptions = [5, 10, 25, 100];
  total = 0;

  subscription = new Subscription();

  nameForm = new FormControl();
  cityForm = new FormControl();
  countryForm = new FormControl();

  constructor(
    private dialog: MatDialog,
    private store: Store,
    private translateService: TranslateService,
    private filterService: FilterService
  ) {
    this.translateService.get('municipalities').subscribe((x) => {
      this.store.dispatch(new SetTitle(x));
    });
  }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;

    this.subscribeEvents();
  }

  subscribeEvents() {
    this.subscription.add(
      this.translateService.onLangChange.subscribe((x) => {
        if (x) {
          this.store.dispatch(
            new FilterMunicipalities(
              this.filterService.generateHttpParams(),
              this.getFilter()
            )
          );
        }
      })
    );

    this.store.dispatch(
      new FilterMunicipalities(
        this.filterService.generateHttpParams(),
        this.getFilter()
      )
    );

    this.subscription.add(
      this.municipalities$.subscribe((x) => {
        this.dataSource = new MatTableDataSource<MunicipalityModel>(x);
      })
    );

    this.subscription.add(
      this.municipalitiesTotal$.subscribe((x) => {
        if (x) {
          this.total = x;
        }
      })
    );
    this.subscription.add(
      this.account$.subscribe((x) => {
        if (x?.userType.toString() === 'Administrator') {
          this.isAdministrator = true;
        }
      })
    );
  }

  deleteMunicipality(event: any, element: MunicipalityModel) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Delete Municipality',
        text: 'Are you sure you want to delete this municipality?',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.store.dispatch(new RemoveMunicipality(element.id));
      }
    });
  }

  addMunicipality() {
    const dialogRef = this.dialog.open(ManageMunicipalityComponent, {
      data: {
        mode: OperationMode.Create,
      },
    });
  }

  editMunicipality(event: any, model: MunicipalityModel) {
    const dialogRef = this.dialog.open(ManageMunicipalityComponent, {
      data: {
        model: model,
        mode: OperationMode.Edit,
      },
    });
  }

  previewBuildingsInMunicipality(event: any) {}

  import() {}

  setAcceptFiles() {
    return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  }

  onFileChange(event: any) {
    if (event.target.files && event.target.files.length) {
      const reader = new FileReader();
      const [file] = event.target.files;
      reader.onload = () => {
        const base64Data = reader.result.toString();

        event.target.value = '';
        this.store.dispatch(new ImportMunicipalities(base64Data));
      };
      // Read the file
      reader.readAsDataURL(file);
    }
  }

  filterMunicipalities() {
    this.store.dispatch(
      new FilterMunicipalities(
        this.filterService.generateHttpParams(),
        this.getFilter()
      )
    );
  }

  clearFilter() {
    this.clear();

    this.store.dispatch(
      new FilterMunicipalities(
        this.filterService.generateHttpParams(),
        this.getFilter()
      )
    );
  }

  clear() {
    this.nameForm.setValue('');
    this.cityForm.setValue('');
    this.countryForm.setValue('');
  }

  getFilter() {
    const newFilter = new MunicipalityFilter();
    newFilter.name = this.nameForm.value;
    newFilter.city = this.cityForm.value;
    newFilter.country = this.countryForm.value;
    newFilter.countBuildings = true;
    return newFilter;
  }

  changePage(event: PageEvent) {
    this.filterService.page = event;
    this.store.dispatch(
      new FilterMunicipalities(
        this.filterService.generateHttpParams(),
        this.getFilter()
      )
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
